export default __webpack_public_path__ + "static/media/ST1_SLEEK_MOIST_550_C.17548c05.b0670fe0.png";